import { StyledQuantitySection, StyledWhispersOfferSection } from './style';

interface IWhispersOfferSection {
  quantityDisplay: string;
  strokedSaleQuantity?: string;
  images: Record<string, string>;
  children: JSX.Element;
}

export const WhispersOfferSection: React.FC<IWhispersOfferSection> = ({
  quantityDisplay,
  strokedSaleQuantity,
  images = { productPrefix: '' },
  children,
}) => {
  return (
    <StyledWhispersOfferSection gap={'3px'}>
      {quantityDisplay && (
        <StyledQuantitySection gap={'4px'}>
          {images.productPrefix && (
            <img src={images.productPrefix} alt="product prefix" />
          )}
          {strokedSaleQuantity && (
            <span className="stroked-quantity">{strokedSaleQuantity}</span>
          )}
          <span className="quantity">{quantityDisplay}</span>
        </StyledQuantitySection>
      )}
      {children}
    </StyledWhispersOfferSection>
  );
};
